<template>
  <div>
    <BaseHeadline
      icon="mdi-file-document"
      :showOnMobile="true"
      :breadcrumbs="breadcrumbsData"
      :showBreadcrumbsOnMobile="true"
      :headerName="
        building && building.title ? `Tegninger - ${building.title}` : ''
      "
    >
    </BaseHeadline>

    <DocumentsList
      :documents="data"
      :loading="loading"
      :itemName="$route.params.building ? 'fileName' : 'name'"
      @click="clickBtn"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import projectApi from "@/api/projectApi";
import documentApi from "@/api/documentApi";
import { Breadcrumbs, ProjectObject } from "@/types/interface";

import {
  DocumentObject,
  DocumentsBreadcrumbs,
} from "@/types/documentInterface";

import DocumentsList from "@/components/shared/documents/DocumentsList.vue";

export default Vue.extend({
  data() {
    return {
      loading: true,
      project: {} as ProjectObject,
      documents: new Array<DocumentObject>(),
      breadcrumbs: new Array<DocumentsBreadcrumbs>(),
      building: {},
    };
  },
  async created() {
    await this.fetchData();
  },

  watch: {
    $route() {
      this.fetchData();
    },
  },

  methods: {
    async fetchData() {
      this.loading = true;
      this.documents = [];
      if (this.$route.name === "BuildingBlueprintsViewUuid") {
        await documentApi
          .getDocumentsUuid(this.$route.params.id, this.$route.params.uuid)
          .then((repsonse) => {
            this.documents = repsonse.documents;
            let building = [...repsonse.breadCrumbs];
            building.splice(0, 3);
            this.building = building[0];

            let breadcrumbs = [...repsonse.breadCrumbs];
            breadcrumbs.splice(0, 4);
            this.breadcrumbs = breadcrumbs;

            this.loading = false;
            this.project = repsonse.project;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        documentApi
          .getBlueprintsHouseDocuments(
            this.$route.params.id,
            this.$route.params.houseId
          )
          .then((repsonse) => {
            this.documents = repsonse.documents;

            this.building = repsonse.breadCrumbs[0]
              ? repsonse.breadCrumbs[0]
              : repsonse.breadCrumbs;

            this.loading = false;
            this.project = repsonse.project;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    clickBtn(document: DocumentObject) {
      if (!document.extension) {
        //Is folder
        this.$router.push({
          name: "BuildingBlueprintsViewUuid",
          params: { uuid: document.uuid },
        });
      } else {
        this.download(document);
      }
    },
    download(document) {
      documentApi.downloadDocument(document);
    },
  },

  computed: {
    data(): Array<any> {
      if (this.$route.params.building && this.documents.length > 0) {
        this.$route.params.building;
        var building = (this as any).documents.find(
          (x) => x.name === this.$route.params.building
        );

        return building.list;
      }
      return this.documents;
    },
    breadcrumbsData(): Array<Breadcrumbs> {
      if (this.project) {
        var data = [
          {
            disabled: false,
            text: this.project.name,
            to: {
              name: "Project",
              params: { id: this.$route.params.id },
            },
            exact: true,
          },
          {
            disabled: this.$route.params.uuid ? false : true,
            text: (this as any).building.title,
            to: { name: "BuildingBlueprintsView" },
            exact: true,
          },
        ];

        if (this.$route.params.uuid && this.breadcrumbs.length > 0) {
          let breadcrumbs = this.breadcrumbs;

          let breadcrumbsMaped = breadcrumbs.map((x) => {
            return {
              disabled: x.last,
              text: x.title,
              to: {
                name: "BuildingBlueprintsViewUuid",
                params: { uuid: x.id },
              },
              exact: true,
            };
          });

          return [...data, ...breadcrumbsMaped];
        }

        return data;
      }

      return [];
    },
    upload(): Vue & { value: string | null } {
      return this.$refs.upload as Vue & {
        value: "";
      };
    },
  },

  components: {
    BaseHeadline,
    DocumentsList,
  },
});
</script>

<style lang="scss">
.alertStyle {
  .v-alert__wrapper {
    .v-alert__icon.v-icon:after {
      background: transparent !important;
    }
  }
}
</style>
